"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEEKEND_ADJUSTMENT_OPTIONS = exports.WEEKEND_ADJUSTMENT_NEXT_COPY = exports.WEEKEND_ADJUSTMENT_PREVIOUS_COPY = exports.WEEKEND_ADJUSTMENT_NONE_COPY = exports.PAYCHECK_WEEKEND_LABEL_COPY = void 0;
exports.PAYCHECK_WEEKEND_LABEL_COPY = "When payday falls on a weekend";
exports.WEEKEND_ADJUSTMENT_NONE_COPY = "Keep the scheduled date";
exports.WEEKEND_ADJUSTMENT_PREVIOUS_COPY = "The Friday before";
exports.WEEKEND_ADJUSTMENT_NEXT_COPY = "The Monday after";
/** The edit control's options, in the model's order. */
exports.WEEKEND_ADJUSTMENT_OPTIONS = [
    { value: "none", label: exports.WEEKEND_ADJUSTMENT_NONE_COPY },
    { value: "previous_weekday", label: exports.WEEKEND_ADJUSTMENT_PREVIOUS_COPY },
    { value: "next_weekday", label: exports.WEEKEND_ADJUSTMENT_NEXT_COPY },
];
//# sourceMappingURL=paycheckWeekendCopy.js.map